// Quotrell Wishlist — localStorage based, no login required
(function() {
  'use strict';
  
  const STORAGE_KEY = 'quotrell_wishlist';
  
  function getWishlist() {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch(e) { return []; }
  }
  
  function setWishlist(items) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    } catch(e) {}
  }
  
  function isInWishlist(handle) {
    return getWishlist().includes(handle);
  }
  
  function trackToKlaviyo(eventName, handle) {
    // Klaviyo identifies via cookie (set when user signed up/checked out earlier)
    // Fetch product details, then push event
    try {
      window._learnq = window._learnq || [];
      // Product Recently Added event for analytics
      fetch('/products/' + handle + '.json?country=NL').then(r => r.ok ? r.json() : null).then(data => {
        if (!data || !data.product) return;
        const p = data.product;
        const variant = p.variants && p.variants[0];
        const price = variant ? variant.price : '0.00';
        const image = (p.images && p.images[0] && p.images[0].src) || (p.image && p.image.src) || '';
        const url = 'https://www.quotrell.com/products/' + handle;
        const payload = {
          ProductName: p.title,
          ProductHandle: handle,
          ProductId: p.id,
          ProductUrl: url,
          ImageUrl: image,
          Price: parseFloat(price),
          PriceFormatted: '€' + price,
          Currency: 'EUR',
          Vendor: p.vendor || 'Quotrell'
        };
        window._learnq.push(['track', eventName, payload]);
        // Update profile property with current wishlist count + handles (for segmentation)
        const items = getWishlist();
        window._learnq.push(['identify', {
          'wishlist_count': items.length,
          'wishlist_handles': items.join(','),
          'wishlist_last_added': eventName === 'Added to Wishlist' ? p.title : undefined
        }]);
      }).catch(()=>{});
    } catch(e) {}
  }
  
  function toggleWishlist(handle) {
    const items = getWishlist();
    const idx = items.indexOf(handle);
    const wasIn = idx >= 0;
    if (wasIn) {
      items.splice(idx, 1);
    } else {
      items.push(handle);
    }
    setWishlist(items);
    updateAllHearts();
    updateCounter();
    // Fire Klaviyo event (only on ADD — remove is less actionable for flows)
    if (!wasIn) {
      trackToKlaviyo('Added to Wishlist', handle);
    } else {
      trackToKlaviyo('Removed from Wishlist', handle);
    }
    return items.includes(handle);
  }
  
  function updateAllHearts() {
    document.querySelectorAll('[data-wishlist-toggle]').forEach(btn => {
      const handle = btn.dataset.wishlistToggle;
      const active = isInWishlist(handle);
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      btn.setAttribute('aria-label', active ? 'Remove from wishlist' : 'Add to wishlist');
    });
  }
  
  function updateCounter() {
    const count = getWishlist().length;
    document.querySelectorAll('[data-wishlist-count]').forEach(el => {
      el.textContent = count;
      el.classList.toggle('is-visible', count > 0);
    });
  }
  
  function handleClick(e) {
    const btn = e.target.closest('[data-wishlist-toggle]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    toggleWishlist(btn.dataset.wishlistToggle);
    
    // If we're on the wishlist page, remove the item card from DOM
    const wishlistItem = btn.closest('.wishlist-item');
    if (wishlistItem) {
      wishlistItem.remove();
      const container = document.querySelector('[data-wishlist-render]');
      if (container && container.querySelectorAll('.wishlist-item').length === 0) {
        container.innerHTML = '<div class="wishlist-empty"><p style="margin:0 0 24px 0;font-size:18px;line-height:1.4;color:#000;">Your wishlist is empty.</p><a href="/" class="wishlist-empty__cta">Browse products</a></div>';
      }
    }
  }
  
  async function renderWishlistPage() {
    const container = document.querySelector('[data-wishlist-render]');
    if (!container) return;
    
    const handles = getWishlist();
    if (handles.length === 0) {
      container.innerHTML = `
        <div class="wishlist-empty">
          <p style="margin:0 0 24px 0;font-size:18px;line-height:1.4;color:#000;">Your wishlist is empty.</p>
          <a href="/" class="wishlist-empty__cta">Browse products</a>
        </div>`;
      return;
    }
    
    container.innerHTML = '<div class="wishlist-loading" style="padding:48px;text-align:center;color:#666;">Loading...</div>';
    
    const products = [];
    for (const handle of handles) {
      try {
        const r = await fetch('/products/' + handle + '.json?country=NL');
        if (r.ok) {
          const data = await r.json();
          if (data.product) {
            const p = data.product;
            products.push({
              handle: p.handle,
              title: p.title,
              featured_image: p.image?.src || p.images?.[0]?.src || '',
              price: p.variants?.[0]?.price || '0.00'
            });
          }
        }
      } catch(e) {}
    }
    
    if (products.length === 0) {
      container.innerHTML = '<div class="wishlist-empty"><p>Some products could not be loaded.</p></div>';
      return;
    }
    
    const html = `<div class="wishlist-grid">${products.map(p => `
      <div class="wishlist-item">
        <a href="/products/${p.handle}" class="wishlist-item__link">
          <div class="wishlist-item__image-wrap">
            <img src="${p.featured_image}" alt="${p.title}" loading="lazy" />
            <button class="wishlist-remove" data-wishlist-toggle="${p.handle}" aria-label="Remove from wishlist">×</button>
          </div>
          <div class="wishlist-item__info">
            <h3 class="wishlist-item__title">${p.title}</h3>
            <p class="wishlist-item__price">€${p.price}</p>
          </div>
        </a>
      </div>
    `).join('')}</div>`;
    
    container.innerHTML = html;
    updateAllHearts();
  }
  
  function init() {
    updateAllHearts();
    updateCounter();
    document.addEventListener('click', handleClick);
    
    if (document.querySelector('[data-wishlist-render]')) {
      renderWishlistPage();
    }
  }
  
  // Listen for storage events from other tabs
  window.addEventListener('storage', e => {
    if (e.key === STORAGE_KEY) {
      updateAllHearts();
      updateCounter();
    }
  });
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  
  window.QuotrellWishlist = { toggle: toggleWishlist, get: getWishlist, isIn: isInWishlist };
})();
